import { axios } from '../util'
import JSONbig from 'json-bigint'

const GET_ACCOUNT_ENDPOINT = '/v5/me'

export const getAccount = () => {
  const config = {
    url: GET_ACCOUNT_ENDPOINT,
    method: 'get',
    transformResponse: [
      function (data) {
        try {
          return JSONbig.parse(data)
        } catch (error) {
          console.error('Error parsing JSON:', error)
          return data
        }
      },
    ],
  }
  return axios(config).then(({ data }) => data)
}
